/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BranchGroup } from '../../models/branch-group';
import { BranchGroupCreateRequest } from '../../models/branch-group-create-request';

export interface CreateBranchGroup$Params {
      body: BranchGroupCreateRequest
}

export function createBranchGroup(http: HttpClient, rootUrl: string, params: CreateBranchGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<BranchGroup>> {
  const rb = new RequestBuilder(rootUrl, createBranchGroup.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BranchGroup>;
    })
  );
}

createBranchGroup.PATH = '/api/v1/branches/groups';
